import { render } from "./maternity_delivery.vue?vue&type=template&id=48bf371f&scoped=true"
import script from "./maternity_delivery.vue?vue&type=script&lang=js"
export * from "./maternity_delivery.vue?vue&type=script&lang=js"

import "./maternity_delivery.vue?vue&type=style&index=0&id=48bf371f&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bf371f"]])

export default __exports__